import clsx from "clsx";
import { get, isEmpty, sortBy } from "lodash";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { changeLanguage } from "../../../../actions/languageAction";
import { setLanguageInStorage } from "../../../../shared/utility";

const LanguageDropdown = ({ selectedLanguage }) => {
    const dispatch = useDispatch();
    const { getLanguageData } = useSelector((state) => state.language);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change */
    const localisedValues = useLanguageChange();

    const languageArrayList = useMemo(() => {
        let languageList = get(getLanguageData, "activeLanguageList", []);
        if (!isEmpty(languageList)) languageList = sortBy(languageList, ["languageName"]);
        return languageList;
    }, [getLanguageData]);

    const selectedLanguageTitle = useMemo(() => {
        const languageCode = selectedLanguage.languageCode;
        return languageCode?.split("_")[0].toUpperCase();
    }, [selectedLanguage]);

    const handleLanguageChange = (lang) => {
        dispatch(changeLanguage(lang));
        setLanguageInStorage(lang);
    };

    return (
        <div className='topbar-button topbar-dropdown language-selection' data-testid='language-selection'>
            <div className='dropdown custom-dropdown button custom-tooltip tooltip-auto-width m-hide'>
                <button
                    className='btn dropdown-toggle triangle-none topbar-btn'
                    type='button'
                    id='language-dropdown'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                >
                    <span className='ln-short-text'>{selectedLanguageTitle}</span>
                </button>
                <div className='dropdown-menu right' aria-labelledby='language-dropdown'>
                    <div className='dropdown-menu-in available-language-list custom-scroll-thin'>
                        <ul>
                            {languageArrayList.map((language) => {
                                return (
                                    <li key={language.languageCode} data-testid='languageBox'>
                                        <div className='dropdown-item-div'>
                                            <button
                                                className={clsx("dropdown-item", language.languageCode === selectedLanguage.languageCode && "active")}
                                                onClick={() => handleLanguageChange(language)}
                                                data-testid={language.languageCode + "-select-btn"}
                                            >
                                                <div className='available-language-box'>
                                                    <div className={clsx("flag-icon", language.class)}></div>
                                                    <div className='language-name'>
                                                        <div className='country-language'>{language.languageName}</div>
                                                        <div className='country-name'>{language.countryName}</div>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
                <div className='custom-tooltip-content text-nowrap'>
                    <div className='custom-tooltip-in' data-testid='langToolTip'>
                        <p>{localisedValues?.language}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

LanguageDropdown.propTypes = {
    selectedLanguage: PropTypes.object,
};

export default LanguageDropdown;
